const prefersReducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)');

if (!prefersReducedMotion || !prefersReducedMotion.matches) {
  const STAGGER_STEP_MS = 90;

  const revealObserver = new IntersectionObserver(
    (entries, observer) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        const el = entry.target;

        if (!el.classList.contains('is-revealed')) {
          el.classList.add('is-revealed');
        }

        observer.unobserve(el);
      }
    },
    {
      threshold: 0,
      rootMargin: '0px 0px -10% 0px',
    },
  );

  function applyStagger(containerSelector, itemSelector, limit = Infinity) {
    document.querySelectorAll(containerSelector).forEach((container) => {
      const items = container.querySelectorAll(itemSelector);
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if (i >= limit) break;
        if (!item.hasAttribute('data-reveal')) {
          item.setAttribute('data-reveal', 'item');
        }
        if (!item.style.getPropertyValue('--reveal-index')) {
          item.style.setProperty('--reveal-index', String(i + 1));
        }
      };
    });
  }

  function initScrollReveal() {
    // Sections on the home page (and generally across the site)
    document
      .querySelectorAll(
        '.hero, .section.section--page-width, .section.section--full-width, .statistics-banner, .why-us',
      )
      .forEach((sectionEl) => {
        if (!sectionEl.hasAttribute('data-reveal')) {
          sectionEl.setAttribute('data-reveal', 'section');
        }
      });

    // Feature card grid
    applyStagger('.feature-cards', '.feature-card');

    // Requirement card grid
    applyStagger('.requirement-cards', '.requirement-card');

    // Collection list cards
    applyStagger('.section-resource-list', '.resource-list__item');

    // Gallery carousel cards
    applyStagger('.gallery-carousel__swiper', '.gallery-card', 3);

    // Collection carousel cards
    applyStagger('.collection-carousel__swiper', '.collection-carousel__card', 4);

    // Statistics items
    applyStagger('.statistics-banner__stats', '.statistics-banner__stat-item');
    document.querySelectorAll('.statistics-banner__image-wrapper').forEach((imageEl) => {
      if (!imageEl.hasAttribute('data-reveal')) {
        imageEl.setAttribute('data-reveal', 'item');
      }
    });

    // Why-us content as a small group
    document.querySelectorAll('.why-us__content').forEach((contentEl) => {
      if (!contentEl.hasAttribute('data-reveal')) {
        contentEl.setAttribute('data-reveal', 'item');
      }
    });

    // Hero content wrapper: subtle reveal separate from media
    document.querySelectorAll('.hero__content-wrapper').forEach((contentEl) => {
      if (!contentEl.hasAttribute('data-reveal')) {
        contentEl.setAttribute('data-reveal', 'item');
      }
    });

    // Observe all revealable elements
    document.querySelectorAll('[data-reveal]').forEach((el) => {
      // Provide a default delay for items if not explicitly set
      if (!el.style.getPropertyValue('--reveal-delay-step')) {
        el.style.setProperty('--reveal-delay-step', `${STAGGER_STEP_MS}ms`);
      }

      revealObserver.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollReveal);
  } else {
    initScrollReveal();
  }
}